import { P2bClient, P2bError } from '@p2b/sdk';
import { createAuthClient } from 'better-auth/react';
import { magicLinkClient, organizationClient } from 'better-auth/client/plugins';

/** The REST client; in the browser it rides on the session cookie. */
export const api = new P2bClient({ baseUrl: window.location.origin, credentials: 'include', client: 'web' });

export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: '/api/auth',
  plugins: [magicLinkClient(), organizationClient()],
});

export { P2bError };

/** Display a project reference in URLs: /projects/<org>/<slug>. */
export function projectRef(org: string, slug: string): string {
  return `${org}~${slug}`;
}
